import type { ReportFilterSelectOption } from '../../shared/report-filter-select-option.model';
import { REPORT_RECORD_COUNT_ELEMENT_ID } from '../../agreements/report-record-count.constants';

/** Activity Handler activity name for material summary report. */
export const MATERIAL_SUMMARY_ACTIVITY = 'Get-Material-Summary' as const;

/** Allowed `recordType` values (case-insensitive on the wire). */
export const MATERIAL_SUMMARY_RECORD_TYPES = ['receipt', 'dispatched', 'processed'] as const;

/** Excel structured table name for Material Summary output. */
export const MATERIAL_SUMMARY_TABLE_NAME = 'TraceMaterialSummary';

/**
 * Origin facility `<select>` — options from {@link TraceUserInfoStore.getDynamicFilterOptions}.
 */
export const MATERIAL_SUMMARY_ORIGIN_FACILITY_ELEMENT_ID = 'filter-ms-origin-facility';

/**
 * Destination facility `<select>` — same option list as origin.
 */
export const MATERIAL_SUMMARY_DESTINATION_FACILITY_ELEMENT_ID = 'filter-ms-destination-facility';

export const MATERIAL_SUMMARY_REPORT_DATE_ELEMENT_ID = 'filter-ms-report-date';

export const MATERIAL_SUMMARY_FROM_DATE_ELEMENT_ID = 'filter-ms-from-date';

export const MATERIAL_SUMMARY_TO_DATE_ELEMENT_ID = 'filter-ms-to-date';

export const MATERIAL_SUMMARY_MATERIAL_TYPE_NAME_ELEMENT_ID = 'filter-ms-material-type-name';

export const MATERIAL_SUMMARY_INPUT_MATERIAL_TYPE_ID_ELEMENT_ID =
    'filter-ms-input-material-type-id';

export const MATERIAL_SUMMARY_REPORT_ALIAS_ELEMENT_ID = 'filter-ms-report-alias';

/** Reuses `#report-record-count-field` mount; options match {@link MATERIAL_SUMMARY_RECORD_COUNT_ALLOWED}. */
export const MATERIAL_SUMMARY_RECORD_COUNT_ELEMENT_ID = REPORT_RECORD_COUNT_ELEMENT_ID;

export const MATERIAL_SUMMARY_RECORD_COUNT_DEFAULT_VALUE = '500';

/** Allowed `recordCount` values for Material Summary pagination. */
export const MATERIAL_SUMMARY_RECORD_COUNT_ALLOWED: readonly number[] = [
    500, 1_000, 5_000, 10_000, 25_000, 50_000, 100_000,
];

export const MATERIAL_SUMMARY_RECORD_COUNT_SELECT_OPTIONS: readonly ReportFilterSelectOption[] =
    MATERIAL_SUMMARY_RECORD_COUNT_ALLOWED.map((n) => ({
        value: String(n),
        label: String(n),
    }));

export function resolveMaterialSummaryRecordCount(value: number | undefined): number {
    if (typeof value === 'number' && MATERIAL_SUMMARY_RECORD_COUNT_ALLOWED.includes(value)) {
        return value;
    }
    return 5000;
}
